import { ThunderboltOutlined } from '@ant-design/icons'
import truckFront from '@assets/CustomIcons/request_truck_front.svg'
import { GraviButton, Horizontal, Texto, Vertical, addCommasToNumber } from '@gravitate-js/excalibrr'
import { Form, Select } from 'antd'
import React, { useMemo } from 'react'
export const ByCompartmentRow = ({
  formattedVolume,
  index,
  requestedProducts,
  productsList,
  compartments,
  compartmentDefaultVolumes,
  form,
  handleCompartmentChange,
}) => {
  const productOptions = useMemo(() => {
    return productsList.map((product) => ({
      label: `${product.product_name} (${product.island})`,
      value: product.product_name,
    }))
  }, [productsList])

  const showAutoFillButton = useMemo(() => {
    if (!requestedProducts?.length) return false
    const hasProductsAtLaterIndexes = requestedProducts.find((item) => item.compartment > index)
    const productIsSelected = requestedProducts.find((item) => item.compartment === index)
    const isNotLast = compartments?.length > index + 1
    return !hasProductsAtLaterIndexes && productIsSelected && isNotLast
  }, [requestedProducts])

  const autoFillCompartments = () => {
    const product = requestedProducts?.find((item) => item.compartment === index)?.product_name
    compartments.forEach((c, i) => {
      if (i > index && !requestedProducts.find((item) => item.compartment === i)) {
        form.setFieldsValue({ [`compartment ${i}`]: product })
      }
    })
    const formData = form.getFieldsValue()
    handleCompartmentChange(formData)
  }

  return (
    <Horizontal key={index} className={'bordered p-3'} verticalCenter>
      <Horizontal flex={1} alignItems={'flex-end'} justifyContent={'flex-start'} verticalCenter={false}>
        <Texto className={'mr-1'} style={{ marginBottom: '-4px', fontSize: '12px' }}>
          {index + 1}
        </Texto>
        <CompartmentView key={`compartment-${index}`} index={index} compartments={compartments} />
      </Horizontal>
      <Vertical flex={1} alignItems={'end'}>
        <Texto textTransform={'lowercase'} category={'p2'} align={'right'}>
          {compartmentDefaultVolumes?.[index] && addCommasToNumber(compartmentDefaultVolumes?.[index])}{' '}
          {formattedVolume}s
        </Texto>
      </Vertical>
      <Horizontal flex={2} alignItems={'center'} justifyContent={'end'}>
        {showAutoFillButton && (
          <GraviButton
            buttonText={'Auto Fill'}
            icon={<ThunderboltOutlined />}
            theme1
            style={{ borderRadius: '5px' }}
            className={'mr-2'}
            onClick={autoFillCompartments}
          />
        )}
        <Form.Item className={'m-0'} name={`compartment ${index}`}>
          <Select options={productOptions} style={{ width: '150px' }} allowClear showSearch />
        </Form.Item>
      </Horizontal>
    </Horizontal>
  )
}

const CompartmentView = ({ index, compartments }) => {
  return (
    <Horizontal justifyContent={'flex-start'} alignItems={'flex-end'}>
      <img src={truckFront} alt={`trailer compartment #${index}`} className={'m-0'} />
      {compartments.map((compartment, i) => {
        const background = i === index ? 'var(--theme-color-1)' : 'var(--gray-300)'
        const borderRight = i === compartments.length - 1 ? '1px solid var(--theme-color-1)' : 'none'
        return (
          <div
            style={{
              border: '1px solid var(--theme-color-1)',
              background,
              width: '12px',
              height: '14px',
              borderRight,
            }}
          ></div>
        )
      })}
    </Horizontal>
  )
}
